import { BadgeKey } from './badgeHelper';

export function selectCompatibleWith(extension?: schema.oaf.Force_Listing): string[] {
    // Compatibility features that comes from 'productsSupported' as strings directly
    const compatibleWith: string[] = extension?.productsSupported || [];
    return compatibleWith;
}

export function selectRequiredProducts(extension?: schema.oaf.Force_Listing): string[] {
    // Required Products comes from 'productsSupported' as strings directly
    return extension?.productsRequired || [];
}

export function selectRequiredListings(extension?: any): string[] {
    // Required app listings comes from 'listingsRequired' as listing IDs
    // This field can be present in different listing types (Force_Listing, Force_CopilotListing, etc.)
    return extension?.listingsRequired || [];
}

export function selectSalesforceEditions(extension?: schema.oaf.Force_Listing): BadgeKey[] {
    // Salesforce editions come from 'editions' of an 'extended listing' delivering the key in 'i18n'.
    // We filter the 'PP' for business reasons.
    return (extension?.editions?.filter((editions) => editions !== 'PP') || []) as BadgeKey[];
}

export function selectLanguages(extension?: schema.oaf.Force_Listing): BadgeKey[] {
    // Supported languages come from 'languages' as language codes keying into 'i18n'.
    return (extension?.languages || []) as BadgeKey[];
}
